import * as React from 'react';
import { observer } from 'mobx-react';
import { Alert, Box, Container, Typography } from '@mui/material';
import BaseButton from '../../components/BaseButton';
import CompanyLogo from '../../components/CompanyLogo';
import Footer from '../../components/Footer';
import authStore from '../../store/Auth';

const Login = observer(() => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
      }}
    >
      <Container
        maxWidth='lg'
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <CompanyLogo />
        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
            justifyContent: 'center', // horizontálně na střed
            alignItems: 'center', // vertikálně na střed
          }}
        >
          <Container
            maxWidth='xs'
            sx={{
              boxShadow: 0,
              backgroundColor: 'white',
              borderRadius: 6,
              p: 3,
              border: '2px solid #ff5f1f',
              fontFamily: "'Source Sans 3', sans-serif",
            }}
          >
            <Box sx={{ mb: 3 }}>
              <Typography
                variant='h5'
                align='center'
                sx={{
                  fontWeight: 700,
                  mb: 2,
                  fontFamily: "'Source Sans 3', sans-serif",
                }}
              >
                MetaMAP Cloud
              </Typography>

              <Typography
                align='left'
                sx={{
                  fontFamily: "'Source Sans 3', sans-serif",
                  fontWeight: 300,
                  fontSize: '1.1rem',
                  lineHeight: 1.5,
                }}
              >
                Log in to launch a new run or review your results. Microbiome
                profiling made simple.
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'inline-flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
              }}
            >
              <BaseButton
                text='Log in'
                variant='contained'
                color='primary'
                isDisabled={authStore?.user?.isLoading}
                spinner={authStore?.user?.isLoading}
                onClick={() => authStore?.user?.signinRedirect()}
              />
            </Box>
            {authStore.user?.error && (
              <Box sx={{ mt: 2 }}>
                <Alert severity='error'>{authStore.user?.error?.message}</Alert>
              </Box>
            )}
          </Container>
        </Box>
      </Container>
      <Footer auth={false} />
    </Box>
  );
});

export default Login;
